/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('AdministrationUsers', function ($scope, $q, $http, _$toast) {
	$scope.users = [];
	$scope.options = {
		currentPage: 1,
		totalItems: 4,
        perPage: 1,
		name: {
			model: {value: "", symbol: "text"}
		},
		surname: {
			model: {value: "", symbol: "text"}
		}
	};

	$scope.getSelected = function(){
		var filteredArray = _.filter($scope.users,function(user) {
			if (user.checked)
				return user;
	   });
		return _.map(filteredArray, function(user) {
				return user.id;
		});
	};
	
	$scope.activate = function(){
		$http.post('/administration/users/activate', $scope.getSelected())
			.success(function(result){
				$scope.getResults();
				_$toast.message('Wybrani użytkownicy zostali aktywowani');
			});
	};
	
	$scope.deactivate = function(){
		$http.post('/administration/users/deactivate', $scope.getSelected())
			.success(function(result){
				$scope.getResults();
				_$toast.message('Wybrani użytkownicy zostali dezaktywowani');
			});
	};
	
	$scope.sticky = {
		show: false,
		activate: $scope.activate,
		deactivate: $scope.deactivate
	};

	$scope.getResults = function () {
		$scope.sticky.show = false;                
		$http.post('/administration/users/list', $scope.options)
			.success(function (result) {
				$scope.options.totalItems = result.totalItems;
				$scope.options.perPage = result.perPage;
				$scope.users = result.data;
				if($scope.users.length > 0)
					$scope.sticky.show = true;
			});
	};


        $scope.onFilter = function(){
            
        };

	$scope._init = function(){
		$scope.getResults();
	};
	$scope._init();
});
                  